export default "__VITE_ASSET__DDl4Ub89__"